import { Component, Input, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { CompanyService } from "src/app/app/company/company.service";
import { EquipmentService } from "src/app/app/equipment/equipment.service";
import { InvitationService } from "src/app/app/invitation/invitation.service";
import { DictionaryService } from "src/app/dictionary";
import { Animations } from "src/app/_helpers/animations";
import { ReportTaskService } from "../report-task/report-task.service";
import { ReportService } from "../report.service";

@Component({
  selector: "app-report-filter-modal",
  templateUrl: "./report-filter-modal.component.html",
  styleUrls: ["./report-filter-modal.component.scss"],
  animations: [Animations.animeHeight, Animations.animeRotate],
})
export class ReportFilterModalComponent {
  constructor(
    public companyServ: CompanyService,
    public translate: TranslateService,
    public dictionaryServ: DictionaryService,
    public modalCtrl: ModalController,
    public invitationServ: InvitationService,
    public equipmentServ: EquipmentService,
    public reportService: ReportService,
    public reportTaskService: ReportTaskService
  ) {}

  showStatus: boolean = false;
  showPriority: boolean = false;
  statusValues;

  pageLoaded: boolean = false;

  @Input()
  page: string;

  ngOnInit() {
    this.pageLoaded = false;

    if (this.page == "report") {
      this.statusValues = this.dictionaryServ.reportStatusValues;
    } else if (this.page == "report-task") {
      this.statusValues = this.dictionaryServ.reportTaskStatusValues;
    }
  }

  ngAfterViewChecked() {
    this.pageLoaded = true;
  }

  onFilterStatus(status) {
    if (!this.pageLoaded) {
      return;
    }

    this.reportService.reportFilter.statusValue = status.detail.value;
    this.reportService.reportFilter.status = this.statusValues.find(
      (el) => el.value === parseInt(status.detail.value)
    );

    this.reportService.reloadFilter();
  }

  onFilterPriority(priority) {
    if (!this.pageLoaded) {
      return;
    }
    this.reportService.reportFilter.priorityValue = priority.detail.value;
    this.reportService.reportFilter.priority = this.dictionaryServ.reportPriorityValues.find(
      (el) => el.value === parseInt(priority.detail.value)
    );
    this.reportService.reloadFilter();
  }

  onClearFilters() {
    this.reportService.reportFilter = {
      statusValue: "null",
      status: null,
      priorityValue: "null",
      priority: null,
    };
    this.reportService.reloadFilter();
  }

  onCloseModal() {
    this.modalCtrl.dismiss();
  }
}
